import { ProductType } from "./formatting/productSchema";

export const getProductUrl = ({ uri, type }: { uri: string; type: string }) => {
  switch (type) {
    case ProductType.Yarn:
      return `/produkt/garn/${uri}`;
    case ProductType.Booklet:
      return `/produkt/hefter/${uri}`;
    case ProductType.Recipe:
      return `/produkt/oppskrifter/${uri}`;
    case ProductType.Accessory:
      return `/produkt/utstyr/${uri}`;
    default:
      console.warn(`No product type found for uri: ${uri}`);
      return "/";
  }
};
